import axios from 'axios';
import apiConfig from '../api.config';

export default function getPaymentSuscriptionStatus({ hotelId }) {
  const {
    host,
    URIs: { paymentSuscriptionStatus },
  } = apiConfig;

  const uri = `${host}${paymentSuscriptionStatus.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data?.suscription || false;
    }).catch(err => {
      console.error(err);
      return false;
    });
}
